import axios from 'axios';

export async function createUberVoucher(phoneNumber, claimId) {
  const requestBody = {
    query: `
    query {
      createUberVoucher(createUberVoucherInput: { phoneNumber: "${phoneNumber}",  claimId: "${claimId}"})  {
        claimId,
      }
    }`,
    queryName: 'create_uber_voucher',
  };
  const response = await axios.post('/api', requestBody);
  return response.data;
}
